import { observer } from "mobx-react";
import DeliverrCredentialsStore from "../../../stores/credentials/deliverr-credentials-store";
import { IValidationGroup } from "../../../../../../hooks/validation-group/validation-group-hook";
import { FormFieldLine } from "../../../../../../components/form-field-line/form-field-line";
import { Input } from "../../../../../../components/inputs/input/input";

interface IProps {
    credentialsStore: DeliverrCredentialsStore,
    vGroup: IValidationGroup,
}

const DeliverrCredentials: React.FC<IProps> = observer(({
    credentialsStore,
    vGroup,
}) => {
    return (
        <>
            <FormFieldLine
                required
                label='Flexport Api Token'
                key='api_token'
                note='Your Flexport Api Token'
            >
                <Input
                    value={credentialsStore.apiToken}
                    onChange={credentialsStore.setApiToken}
                    validationGroup={vGroup}
                    required
                    autoComplete='new-password'
                    type='password'
                />
            </FormFieldLine>
        </>
    );
});

export default DeliverrCredentials;

